import React from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED, BANK_ACCOUNT_I_WILL_PAY_LATER_BUTTON_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_CANCEL_TRANSACTION } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import CanceledOperationModal from '../cheque/modals/CanceledOperationModal';

const PayNotNowPopup = (props) => {
    const { cancelWillPayLater, cancelTransferButtonTitle } = usePageMessages();

    const cancelTransfer = (e) => {
        e?.preventDefault();
        amplitude.getInstance().logEvent(BANK_ACCOUNT_CANCELED_TRANSFER_BUTTON_CLICKED);
        props.popupRef.current.close();
        props.toggleSpinner(true);
        apiFetchData(AUTH_CANCEL_TRANSACTION + '?paymentId=' + props.paymentId)
            .then((json) => {
                if (json.messageBodyMessages) {
                    props.updateMessages(json.messageBodyMessages);
                }
                props.updatePageMessages(json.messages).then(() => {
                    if (json.extra.transactionCanceled) {
                        props.modalRef.current.open(<CanceledOperationModal />);
                    }
                });
            })
            .finally(() => props.toggleSpinner(false));
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton
                text={cancelWillPayLater}
                iconName="clock"
                onClick={(e) => {
                    e.preventDefault();
                    amplitude.getInstance().logEvent(BANK_ACCOUNT_I_WILL_PAY_LATER_BUTTON_CLICKED);
                    props.handleNotNowClick(true);
                    props.popupRef.current.close();
                }}
            />
            <PopupButton text={cancelTransferButtonTitle} iconName="cross" onClick={cancelTransfer} />
        </SimplePopup>
    );
};

PayNotNowPopup.propTypes = {
    popupRef: PropTypes.object.isRequired,
    modalRef: PropTypes.object.isRequired,
    paymentId: PropTypes.number.isRequired,
    handleNotNowClick: PropTypes.func.isRequired,
    updateMessages: PropTypes.func.isRequired,
    updatePageMessages: PropTypes.func.isRequired,
    toggleSpinner: PropTypes.func.isRequired,
};

export default PayNotNowPopup;
